<mat-card mat-ripple>
  <mat-card-content [class.free-item]="isFreeItem()">
    <div class="wrapper-details">
      @if (isFreeItem()) {
        <label class="free-label">GRATIS</label>
      }

      <label class="name">{{ bundleItem().details.name }}</label>
      <span class="details">
        @if (!isFreeItem()) {
          <span>Art.Nr.: {{ bundleItem().sku }} | </span>
        }

        <span>VE: {{ bundleItem().details.packagingUnit }}</span>

        @if (arePricesVisible() && !isFreeItem() && bundleItem().prices?.endUser; as endUserPrice) {
          <span> | {{ bundleItem().prices?.endUserPriceLabel ?? "KVP" }}:
            <ui-product-prices-formatter
              [price]="endUserPrice">
            </ui-product-prices-formatter>
           </span>
        }

        @if (!isFreeItem() && bundleItem().details.articleNumberStable; as articleNumberStable) {
          <span> | Stab. Art.-Nr.: {{ articleNumberStable }}</span>
        }

        @if (!isFreeItem() && bundleItem().details.gtinPackaging; as gtinPackaging) {
          <span> | Stangen-EAN: {{ gtinPackaging }}</span>
        }
      </span>
    </div>

    <div class="wrapper-image">
      <img
        mat-card-image
        [alt]="bundleItem().images[0].large"
        [class.free-item]="isFreeItem()"
        [src]="bundleItem().images[0].small"
      >
    </div>
  </mat-card-content>
</mat-card>

<form [formGroup]="group" class="wrapper-prices-and-controls">
  @if (arePricesVisible() && !isFreeItem() && bundleItem().prices; as prices) {
    <span class="price">
      Einzelpreis:
      <ui-product-prices-formatter
        [price]="prices.singleUnit">
      </ui-product-prices-formatter>
    </span>
  }

  @defer (when dataQuantityCounter() && quantityCounterControl) {
    <ui-form-quantity-counter
      [data]="dataQuantityCounter()"
      [formControlName]="dataQuantityCounter().name"
    ></ui-form-quantity-counter>
  }
</form>
